import React from "react";

import DataSourcesStep from "./steps/DataSourcesStep";
import FinalReviewStep from "./steps/FinalReviewStep";
import LocationSizeStep from "./steps/LocationSizeStep";
import ProjectDetailsStep from "./steps/ProjectDetailsStep";
import PropertyBoundariesStep from "./steps/PropertyBoundariesStep";
import TagsStep from "./steps/TagsStep";
import type { CreateProjectData } from "./types";

interface CreateProjectStepContentProps {
  step: number;
  data: CreateProjectData;
  onNext: () => void;
  onBack: () => void;
  onUpdateData: (updates: Partial<CreateProjectData>) => void;
  /** Replaces the Location & Size step (the listing panel shows its controls only; the map is beside it). */
  locationStep?: React.ReactNode;
  /** After creating; the full-page wizard navigates to the listing instead. */
  onCreated?: () => void;
}

/** One step of the create-project wizard (see wizardSteps.ts for the list). */
export default function CreateProjectStepContent({
  step,
  data,
  onNext,
  onBack,
  onUpdateData,
  locationStep,
  onCreated,
}: CreateProjectStepContentProps) {
  switch (step) {
    case 0:
      return <ProjectDetailsStep data={data} onNext={onNext} onUpdateData={onUpdateData} />;
    case 1:
      return <PropertyBoundariesStep data={data} onNext={onNext} onBack={onBack} onUpdateData={onUpdateData} />;
    case 2:
      return locationStep !== undefined ? (
        <>{locationStep}</>
      ) : (
        <LocationSizeStep data={data} onNext={onNext} onBack={onBack} onUpdateData={onUpdateData} />
      );
    case 3:
      return <DataSourcesStep data={data} onNext={onNext} onBack={onBack} onUpdateData={onUpdateData} />;
    case 4:
      return <TagsStep data={data} onNext={onNext} onBack={onBack} onUpdateData={onUpdateData} />;
    case 5:
      return <FinalReviewStep data={data} onBack={onBack} onUpdateData={onUpdateData} onCreated={onCreated} />;
    default:
      return null;
  }
}
